import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchDoctorOpdBillPaymentRouters = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  return axiosInstance.get(EndPoints.DOCTOR_OPD_BILL_PAYMENT.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
    },
  });
};

export const fetchDoctorOpdBillPaymentDetail = (appointment_id) => {
  const url = EndPoints.DOCTOR_OPD_BILL_PAYMENT.DETAIL + `/${appointment_id}`;

  return axiosInstance.get(url);
};

export const fetchDoctorOpdBillPaymentDropdown = (payload) => {
  return axiosInstance.get(EndPoints.DOCTOR_OPD_BILL_PAYMENT.DROPDOWN, payload);
};

export const createDoctorOpdBillPayment = (payload) => {
  return axiosInstance.post(EndPoints.DOCTOR_OPD_BILL_PAYMENT.CREATE, payload);
};

export const updateDoctorOpdBillPayment = (payload) => {
  return axiosInstance.put(EndPoints.DOCTOR_OPD_BILL_PAYMENT.UPDATE, payload);
};

export const deleteDoctorOpdBillPayment = (payload) => {
  const url = EndPoints.DOCTOR_OPD_BILL_PAYMENT.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadDoctorOpdBillPaymentCSV = () => {
  return axiosInstance.put(
    EndPoints.DOCTOR_OPD_BILL_PAYMENT.DOWNLOAD_CSV,
    {},
    {
      responseType: "blob",
    },
  );
};
